/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import {
  BILLER_INVOICE_STATUS_CANCELLED,
  BILLER_INVOICE_STATUS_DRAFT,
  BILLER_INVOICE_STATUS_OPEN,
  BILLER_INVOICE_STATUS_PAID,
  BILLER_INVOICE_STATUS_PENDING,
  BILLER_INVOICE_STATUS_PROCESSING,
  BILLER_INVOICE_STATUS_VOIDED,
} from './BillerInvoiceStatus.entity.constant';

/**
 * The biller invoice status status.
 * @export
 */
export type EntityBillerInvoiceStatus = io.TypeOf<typeof BillerInvoiceStatus>;

/**
 * The biller invoice status constant.
 * @export
 */
export const BillerInvoiceStatus = io.union(
  [
    io.literal(BILLER_INVOICE_STATUS_DRAFT),
    io.literal(BILLER_INVOICE_STATUS_PENDING),
    io.literal(BILLER_INVOICE_STATUS_OPEN),
    io.literal(BILLER_INVOICE_STATUS_PROCESSING),
    io.literal(BILLER_INVOICE_STATUS_PAID),
    io.literal(BILLER_INVOICE_STATUS_VOIDED),
    io.literal(BILLER_INVOICE_STATUS_CANCELLED),
  ],
  `BillerInvoiceStatus`,
);
